module.exports = __webpack_public_path__ + "assets/static/media/hireprivy_splash_screen_4.27e3f216.png";